import { Component } from '@angular/core';

@Component({
    selector: 'app-terms-conditions',
    imports: [],
    templateUrl: './terms-conditions.component.html',
    styleUrl: './terms-conditions.component.scss'
})
export class TermsConditionsComponent {}